import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { JwtService } from 'src/app/auth/jwt.service';

@Injectable({
  providedIn: 'root'
})
export class CreditmemoService {
  readonly rootUrl = environment.baseUrl;
  constructor(private http: HttpClient, private jwtService: JwtService) { }

  getCreditMemoList(){
    return this.http.get(this.rootUrl + '/api/VendorDashboard/getVendorEnlistmentSteps');
  }



  GetCMHeaderList() {
    return this.http.get(this.rootUrl + '/api/CreditMemo/GetCreditMemoList');
  } 

  // GetGrnLineList(this.orderId) {
  //   return this.http.get(this.rootUrl + '/api/GRN/GetGrnLineData');
  // }
  GetCMLineListById(id) {
    debugger;
    const order = {
      OrderId: id
    }
    return this.http.post(this.rootUrl + '/api/CreditMemo/GetCreditLineData', order);
  }

}
